import c from "../../utils/constants";
import common from "../../utils/common";
import datasets from "../../utils/datasets";

class ChecksController {
  constructor(ChecksService, FilterService, AuthService, NotificationService, $scope) {
    "ngInject"

    this.checksService = ChecksService;
    this.filterService = FilterService;
    this.authService = AuthService;
    this.notificationService = NotificationService;
    this.$scope = $scope;
    this.gridOptions = this.getGridOptions();
  }

  $onInit() {
    this.visaCheckStatusOptions = {
      dataSource: [
        { value: 1, text: "Pending Verification" },
        { value: 2, text: "Approved" },
        { value: 3, text: "Invalid" },
        { value: 4, text: "Expired" },
      ],
      dataTextField: "text",
      dataValueField: "value",
    }
  }

  getGridOptions() {
    return {
      dataSource: this.checksService.getDataSource(this.dataSourceFetchSuccessCallback.bind(this), this.dataSourceErrorSuccessCallback.bind(this)),
      sortable: true,
      pageable: true,
      resizable: true,
      save: this.saveChanges.bind(this),
      height: "90vh",
      noRecords: {
        template: "No Checks."
      },
      columns: [
        {
          field: "fullName", title: "Name", filterable: false, attributes: {"class": "col-name"}, width: "8rem",
          template: (dataItem) => `<a class="cell" href="/users/${dataItem.jugglerId}">${dataItem.fullName}</a>`,
        },
        { field: "visaCheckStatus", title: "Check Status", filterable: false, sortable: false, width: "4rem", template: (dataItem) => `${this._getCheckStatus(dataItem.visaCheckStatus)}` },
        { field: "officialFirstName", title: "Given Name", filterable: false, sortable: false, width: "4rem" },
        { field: "officialLastName", title: "Last Name", filterable: false, sortable: false, width: "4rem" },
        { field: "passportNumber", title: "Passport Number", filterable: false, sortable: false, width: "4rem" },
        { field: "passportCountry", title: "Passport Country", filterable: false, sortable: false, width: "4rem", template: (dataItem) => `${this._getCountry(dataItem.passportCountry)}` },
        // { field: "creationDate", title: "Signup Date", filterable: false, sortable: false, width: "4rem", template: `#= creationDate ? kendo.toString(new Date(creationDate), 'dd/MM/yyyy'): '-' #` },
        { field: "dateOfBirth", title: "Date of Birth", filterable: false, sortable: false, width: "4rem", template: `#= dateOfBirth ? kendo.toString(new Date(dateOfBirth), 'dd/MM/yyyy'): '-' #` },
        { title: "Update Status", command: [{ name: "edit", text: "Update" }], width: "4rem" },
      ],
      editable: {
        mode: "popup",
        window: { title: "Update Check Status" },
        template: kendo.template($("#popup-editor").html())
      }
    }
  }

  saveChanges(e) {
    const check = e.model;

    if ((check.visaCheckStatus == 2) && (!check.visaClass || !check.visaSubclass || !check.visaGrantDate || !check.visaExpiry)) {
      this.notificationService.error("Check missing fields and try again.");
      e.preventDefault();
    }
  }

  applyFilters() {
    this.gridOptions.dataSource.filter(this.filterService.getAppliedFilters());
  }

  dataSourceFetchSuccessCallback(e) {
    this.certificatesMatchCount = this.gridOptions.dataSource.total();
    this.$scope.$apply();
  }

  dataSourceErrorSuccessCallback(e) {
    if (e.xhr.status == 401) {
      this.authService.refreshToken().then((response) => {
        this.applyFilters();
      }).catch((error) => {
        this.authService.logout();
      });
    } else {
      this.authService.logout();
    }
  }

  _getCountry(countryId) {
    const match = datasets.countriesIso.find(country => country.value === countryId || country.alpha2 === countryId);

    if (!match) return "N/A";

    return match.label;
  }

  _getCheckStatus(status) {
    switch(status) {
      case c.visaCheckStatus.PENDINGVERIFICATION:
        return "Pending";
      case c.visaCheckStatus.APPROVED:
        return "Approved";
      case c.visaCheckStatus.INVALID:
        return "Invalid";
      case c.visaCheckStatus.EXPIRED:
        return "Expired";
    }
  }
}

export default ChecksController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/checks/checks.controller.js
 **/